import gql from "graphql-tag";

export default gql`query Quote($id:Int!) {
    quote(id:$id) {
      id
      type
      name
      telephone
      address
      note
      instructed
      dealt
      leadid
      nbmuid
      cqsconfirm
      cqsnote
      ipaddress
      total
      vatrate
      discount
      spdiscount
      noteCosts
      postcodeOrigin
      excludeoffers
      test
      gdpr
      call1
      call1date
      call2
      call2date
      call3
      call3date
      completed
      completeddate
      individuals
      company
      extra
      instructionConfirmationSubmitted
      callback
      timestamp
      quoteAnswers {
        id
        value
        question {
          id
          body
        }
        questionTypeOption {
          id
          value
        }
      }
      quoteType{
        id
        name
      }
      files {
        id
        referencelong
        department{
          id
          name
        }
      }
      user {
        id
        name
      }
      userAgent {
        id
        body
      }
      blacklist {
        ipaddress
      }
      referrer {
        id
        name
      }
      quoteEmails {
        EMAIL_ID
        email {
          id
          address
          personal
          validated
          entity {
            id
            name
          }
        }
      }
      logs {
        id
        timestamp
        logAction {
          id
          body
        }
        emailTemplateRevision{
          id
          subject
          emailTemplate {
            id          
          }
        }
        emails {
          id
          address
          personal
        }
        user {
          id
          name
        }
      }
      scheduledQuoteEmails{
        id
        scheduled
        emailTemplateRevision{
          id
          subject
          emailTemplate {
            id          
          }
        }
        scheduledQuoteEmailQuoteEmails{
          quoteEmail {
            email {
              id 
              address
                  personal
            }
          }
        }
      }
      quoteSections {
        id
        name
        quoteSubSections {
          id
          title {
            id
            value
            description{
              id
              body
              type
            }
            secondary {
              id
              body
            }
          }
          quoteItems {
            id
            value
            description {
              id
              body
              type
            }
            secondary {
              id
              body
            }
          }
        }
      }    
    }
  }`